import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

const client = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

// MERCHANT REFERRALS
export const getAllMerchantReferralCode = accessToken =>
  client({
    url: '/merchant-referral-code/',
    method: 'get',
    headers: {
      'X-Device-Id': generateDeviceId(),
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const getMerchantReferralCodeByMerchant = ({
  merchantName,
  accessToken,
}) =>
  client({
    url: `/merchant-referral-code/merchant?name=${merchantName}`,
    method: 'get',
    headers: {
      'X-Device-Id': generateDeviceId(),
      Authorization: `Bearer ${accessToken}`,
    },
  })
